// src/components/Spinner.js
import React from 'react';
import './Spinner.css'; // Vamos criar este arquivo CSS em breve

function Spinner() {
  return (
    <div className="spinner-container">
      <div className="spinner"></div>
    </div>
  );
}

export default Spinner;
